// extracted by mini-css-extract-plugin
export var header = "_vt-1";
export var maskBottom = "_vt-6";
export var maskMiddle = "_vt-7";
export var maskTop = "_vt-5";
export var root = "_vt-0";
export var scrollDownButton = "_vt-3";
export var scrollDownButtonHidden = "_vt-4";
export var viewport = "_vt-2";